import React, { useEffect, useState } from 'react'
import { Drawer } from 'antd'
import Content from './content'
import styles from './index.less'
import { queryUserConfig } from '@/services/user'
import { getConfigAndFieldsFrom } from './hooks'

// 用于生成用户的配置config,当用户没有配置时(null),那么就从fields中抽取(defaultShow)
// 如果用户有配置时,
//     如果field中有,但是用户配置中没有,那么用field中的配置生成(initShow)
//     如果用户配置中有的话,那么用用户配置
/**
 *
 * @param {*} fields 组件外部传入的fields
 * @param {*} config 用户对筛选区的配置项,为null时表示用户没有配置
 * @returns
 */
const generateConfig = (fields, config) => {
    const defaultSetting = {
        show: true,
        enable: true
    }
    const { targetConfig } = getConfigAndFieldsFrom(fields, config, defaultSetting)
    return targetConfig
}

const Modal = ({
    visible,
    onClose,
    configKey,
    fields,
    onSaveCallback,
    isNewUser,
    groupFields,
    onCollapse,
    hideShowQuickSort
}) => {
    const title = (
        <div className={styles.header}>
            <div className={styles.title}>添加/隐藏搜索条件</div>
            <div className={styles.subTitle}>设置搜索条件隐藏与显示，按使用习惯调整排序</div>
        </div>
    )

    return (
        <Drawer
            className={styles.searchConfigWrapper}
            title={title}
            visible={visible}
            maskStyle={{ background: 'transparent' }}
            headerStyle={{ padding: '24px 24px 12px', border: 'none' }}
            bodyStyle={{ padding: '0 16px' }}
            width="310px"
            destroyOnClose
            onClose={onClose}
        >
            <Content
                configKey={configKey}
                onClose={onClose}
                fields={fields}
                onSaveCallback={onSaveCallback}
                isNewUser={isNewUser}
                groupFields={groupFields}
                onCollapse={onCollapse}
                hideShowQuickSort={hideShowQuickSort}
            />
        </Drawer>
    )
}

export default ({
    queryConfigKey,
    fields,
    onSaveCallback,
    initCallback,
    redDot,
    onClick,
    isNewUser,
    groupFields,
    onCollapse,
    hideShowQuickSort
}) => {
    const [visible, setVisible] = useState(false)
    const [configKeys, setConfigKeys] = useState(null)

    useEffect(() => {
        // 针对打单待发货页面
        if (initCallback) {
            ;(async () => {
                const { data, success } = await queryUserConfig({ configKey: queryConfigKey })
                if (success && data) {
                    setConfigKeys(data)
                    // if (success) {
                    //     setConfigKeys(null)
                } else {
                    initCallback(null, false)
                }
            })()
        }
    }, [])
    useEffect(() => {
        if (configKeys) {
            const config = generateConfig(fields, configKeys[queryConfigKey])
            initCallback && initCallback(config, true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configKeys, fields])

    const btn = (
        <a
            style={{ position: 'relative', whiteSpace: 'nowrap' }}
            onClick={() => {
                onClick && onClick()
                setVisible(true)
            }}
        >
            + 添加/隐藏搜索条件{redDot && <div className={styles.redDot} />}
        </a>
    )

    return (
        <>
            <Modal
                visible={visible}
                onClose={() => {
                    setVisible(false)
                }}
                isNewUser={isNewUser}
                configKey={queryConfigKey}
                fields={fields}
                onSaveCallback={data => {
                    setConfigKeys({
                        [queryConfigKey]: data
                    })
                    onSaveCallback(data)
                }}
                groupFields={groupFields}
                onCollapse={onCollapse}
                hideShowQuickSort={hideShowQuickSort}
            />
            {btn}
        </>
    )
}
